import { styled } from "@mui/material";
import { useTheme } from "@mui/material";

export const MutinexProgress: React.FC = () => {
  const theme = useTheme();

  const isDarkMode = theme.palette.mode === "dark";
  const ANIMATION_TIME = "1.6s";

  return (
    <StyledDiv>
      <StyledSvg width="240" height="240" viewBox="0 0 240 240" xmlns="http://www.w3.org/2000/svg">
        {/* Expanding background circle */}
        <circle cx="120" cy="120" r="90" fill={isDarkMode ? "transparent" : "white"}>
          <animate
            attributeName="r"
            values="80;102.5;80"
            dur={ANIMATION_TIME}
            repeatCount="indefinite"
          />
        </circle>

        {/* Wave animation */}
        <circle
          cx="120"
          cy="120"
          fill="none"
          r="80"
          stroke={theme.palette.brandedTypography.textColor}
          strokeWidth="6"
        >
          <animate
            attributeName="r"
            values="80;102.5;80"
            dur={ANIMATION_TIME}
            repeatCount="indefinite"
          />
          <animate
            attributeName="opacity"
            values="1;0.3;1"
            dur={ANIMATION_TIME}
            repeatCount="indefinite"
          />
        </circle>

        {/* Pulsing and scaling icon */}
        <g transform="translate(120, 120)">
          <animateTransform
            attributeName="transform"
            type="scale"
            additive="sum"
            values="3;3.36;3"
            dur={ANIMATION_TIME}
            repeatCount="indefinite"
          />
          <g transform="translate(-17.5, -16)">
            <path
              d="M24.7273 6.1442L23.1975 8.74608L32.2132 23.9749L35.2727 23.9686L24.7273 6.1442Z M15.6301 2.61442L14.0878 0L0 23.9749L3.07837 23.9687L14.4263 4.65204L15.6301 2.61442Z M19.6552 14.7774L23.4232 21.1473H11.9749L22.7461 2.79624L21.1536 0.112854L7.1348 23.9749L28.2696 23.9687L21.2414 12.0878L19.6552 14.7774Z"
              fill={theme.palette.brandedTypography.textColor}
            >
              <animate
                attributeName="opacity"
                values="1;0.7;1"
                dur={ANIMATION_TIME}
                repeatCount="indefinite"
              />
            </path>
          </g>
        </g>
      </StyledSvg>
    </StyledDiv>
  );
};

export default MutinexProgress;

const StyledDiv = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
});

const StyledSvg = styled("svg")({
  width: "240px",
  height: "240px",
});
